module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEgSURBVFiF7Vc7coUwDFwxORKhxarjOz1zJ6ittI+cKUpDZt4QB1s8HFKwpWfH2tHqYwMXTgalDlsfHSluANwhQQjDfeRQLOD1LeoRgVeQeWJeHzbrg87HUCE4ALjWR5cVUBNNwtIX4x1ChPctgip6GGqnWMBWIa2xFHEs4RZb8AlIKdeCKjWQ8vo3lFugiJ2PQ46nil61goDl8puFX4I/bcN/KcBkARGGXDc0gLNYVWMOSOujnDoHPkYu5hYLIENaLQvNUgNuWdOS46lhmVuXEXDQI+Ubp7fhJeAZAaIEJkJ2QW1hTxGKEoaHXhcAofMx7FlWlgyIEniemFOD5j5ymCcma0Z+CEhMvM3AzwpJ/guWdParVO/CgzXJf8GF0/EFdt1yjNk7YcUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detailIcon.png
// module id = W+zf
// module chunks = 0